export default function(response) {
  if (response.headers['x-refresh-token'] === 'true')
    window.dispatchEvent(new Event('refreshToken'))
  return response
}
